module.exports = __webpack_public_path__ + "img/OPEN.22e3d1c1.svg";